import { useEffect, useState } from "react";
import { Link as RouterLink, Navigate } from "react-router-dom";
import { Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, Chip, Box } from "@mui/material";
import { QuoteController } from "../controllers/quote";
import { useAuth } from "../context/AuthContext";

export default function Quotes() {
  const { user, loading } = useAuth();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    if (!user) return;
    QuoteController.list()
      .then((r) => setRows(r?.items || r || []))
      .catch(() => setRows([]))
      .finally(() => setBusy(false));
  }, [user]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h2" sx={{ fontSize: "1.8rem", mb: 3 }}>Quotes</Typography>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Quote #</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {busy ? (
              <TableRow><TableCell colSpan={4}>Loading…</TableCell></TableRow>
            ) : rows.length === 0 ? (
              <TableRow><TableCell colSpan={4}><Box sx={{ p: 2 }}>No quotes yet.</Box></TableCell></TableRow>
            ) : rows.map((q) => (
              <TableRow key={q.id} hover component={RouterLink} to={`/quotes/${q.id}`}
                sx={{ textDecoration: "none", cursor: "pointer" }}>
                <TableCell>{q.number || q.id}</TableCell>
                <TableCell>{q.date || "—"}</TableCell>
                <TableCell><Chip size="small" label={q.status || "open"} /></TableCell>
                <TableCell align="right">{q.total ? `$${Number(q.total).toFixed(2)}` : "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}
